/* Created By CoolGuy on 2017/12/5
 */
import { observable, action } from 'mobx';
import intl from 'react-intl-universal';
import RootStore from './RootStore';
import { IBasicDialog } from '../components/Dialog/BasicDialog';
import { ReactNode } from 'react';
export default class UIStore {
  @observable toast = {
    icon: '',
    iconSize: '',
    show: false,
    content: '' as ReactNode
  };
  @observable alert = {
    show: false,
    title: '',
    content: '',
    buttons: [
      {
        label: intl.get('ok'),
        onClick: action(() => {
          this.alert.show = false;
        })
      }
    ]
  };
  @observable basicDialog: IBasicDialog = {
    show: false,
    title: '',
    content: '',
    showCancel: false,
    onCancel: () => this.hideBasicDialog()
  };
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action showToast = ({
    icon = 'success-no-circle',
    iconSize = '',
    time = 2000,
    content = '' as ReactNode
  }) => {
    this.toast = { icon, iconSize, content, show: true };
    // console.log('showToast', this.toast);
    if (time) {
      setTimeout(
        action(() => {
          this.hideToast();
        }),
        time
      );
    }
  };
  @action hideToast = () => {
    this.toast = {
      ...this.toast,
      show: false
    };
  };
  @action showAlert = (arg: any) => {
    // if (typeof arg === 'string') {
    //   arg = { content: arg };
    // }
    // this.alert = Object.assign(this.alert, arg, { show: true });
    this.showBasicDialog(arg);
    //console.log(this.alert);
  };
  @action hideAlert = () => {
    this.alert = {
      ...this.alert,
      show: false
    };
  };
  @action showBasicDialog = (arg: any) => {
    if (typeof arg === 'string') {
      arg = { content: arg };
    }
    this.basicDialog = Object.assign(this.basicDialog, arg, { show: true });
  };
  @action hideBasicDialog = () => {
    this.basicDialog = {
      ...this.basicDialog,
      show: false
    };
  };
}
